import { Flex, RemoteImage, Typography } from '@banhala/ui-kit';
import { View, StyleSheet } from 'react-native';
import type { SummaryCardProps } from '../types';

export const SummaryCard = ({ item }: SummaryCardProps) => {
  return (
    <Flex.Row
      padding={{ horizontal: 12 }}
      gap={12}
      alignItems="center"
    >
      <View style={styles.thumbnailContainer}>
        <RemoteImage uri={item.image} width={44} height={44} />
      </View>
      <Flex.Column gap={4} flexShrink={1}>
        {item.tag && (
          <Flex.Row>
            <Flex.Row
              backgroundColor="lilac5"
              borderRadius="xsmall"
              padding={{ horizontal: 6, vertical: 4 }}
            >
              <Typography type="subtitle5" color="content_blue_primary">
                {item.tag}
              </Typography>
            </Flex.Row>
          </Flex.Row>
        )}
        <Typography
          type="body4"
          color="content_primary"
          numberOfLines={1}
          ellipsizeMode="tail"
        >
          {item.name}
        </Typography>
      </Flex.Column>
    </Flex.Row>
  );
};

const styles = StyleSheet.create({
  thumbnailContainer: {
    width: 44,
    height: 44,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.08)',
    overflow: 'hidden',
  },
});
